import API from './api';
import router from '../router';

export default {
  fetchParents() {
    return API().get('parents');
  },
  addParentToStudent(params) {
    return API().post('students-parents', params);
  },
  createStudentParent(parent, relation) {
    return API().post(`students/${router.currentRoute.params.id}/parents`, {
      parent,
      relation,
    });
  },
  updateStudentParent(parent) {
    return API().put(
      `students/${router.currentRoute.params.id}/parents/${parent.id}`,
      {
        parent,
      }
    );
  },
  deleteStudentParentLink(linkId) {
    return API().delete(
      `/students/${router.currentRoute.params.id}/parents/${linkId}`
    );
  },
  getParentsByTeacher(params) {
    return API().get(`parents/teacher/${params.teacherId}`);
  },
  getStudentParents(params) {
    return API().get(`students/${params.id}/parents`);
  },
  getSchoolParents() {
    return API().get(
      `students/${router.currentRoute.params.id}/school-parents`
    );
  },
};
